import React, { useEffect, useState } from "react";
import Navbar from "../Navbar/Navbar";
import { addProjectData } from "../../Redux/Config/Action";
import { getProjectMaster } from "../../Redux/Task/Action";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import NewDataTable from "../DataTable/NewDataTable";
import { FaEdit } from "react-icons/fa";
import { MdAssignmentInd } from "react-icons/md";
import { useNavigate } from "react-router-dom";

const Project = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const token = localStorage.getItem("token");
    const loginId = localStorage.getItem("loginId");
    const { getprojectDropdownData } = useSelector((store) => store.task);
    const [show, setShow] = useState(false);

    const [projectData, setProjectData] = useState({
        projectMasterId: "",
        projectName: "",
        projectCode: "",
        actionType: "INSERT"
    });



    useEffect(() => {
        dispatch(getProjectMaster(token));
    }, [dispatch, token, loginId]);

    const Tooltip = ({ text, children }) => {
        return (
            <div className="tooltip-container">
                {children}
                <div className="tooltip">{text}</div>
            </div>
        );
    };

    const handleProjectEdti = (projectData) => {
        setProjectData({
            projectMasterId: projectData.projectMasterId,
            projectName: projectData.projectName,
            projectCode: projectData.projectCode,
            actionType: "UPDATE"

        });
        setShow(true);

    }

    const handleProjectAssignClick = (row) => {
        navigate("/project-access", {
            state: { row: row }
        });
    }

    const columns = [
        {
            name: "SN",
            cell: (_, index) => index + 1,
            sortable: false,
            width: "80px",
            align: "center",
        },
        {
            name: "Project Short Name",
            selector: (row) => row?.projectCode || "-",
            sortable: true,
            align: "center",
        },
        {
            name: "Project Name",
            selector: (row) => row?.projectName || "-",
            sortable: true,
            align: "center",
        },
        {
            name: "Action",
            selector: (row) => row,
            sortable: false,
            align: "center",
            cell: (row) => (
                <>

                    <Tooltip text="Edit">
                        <FaEdit
                            className="text-warning me-2 cursor-pointer" size={22}
                            onClick={() => handleProjectEdti(row)}
                        />
                    </Tooltip>
                    <Tooltip text="Assign">
                        <MdAssignmentInd
                            className="text-success cursor-pointer" size={22}
                            onClick={() => handleProjectAssignClick(row)}
                        />
                    </Tooltip>

                </>
            ),

        },
    ];


    const clearLeaveInputFields = () => {
        setProjectData({
            projectMasterId: "",
            projectName: "",
            projectCode: "",
            actionType: "INSERT"
        });
    };

    const handleClose = () => {
        clearLeaveInputFields();
        setShow(false);
    };

    const handleChange = (e) => {
        const { id, value } = e.target;
        setProjectData((prevData) => {
            let updatedData = {
                ...prevData,
                [id]: value,
            };
            return updatedData;
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const payload = {
            ...projectData,
            projectCode: projectData.projectCode?.trim(),
        }
        const result = await Swal.fire({
            title: "Are you sure?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, submit it!",
            cancelButtonText: "No, cancel",
        });
        if (result.isConfirmed) {
            dispatch(addProjectData(payload, token))
                .then((response) => {
                    if (response.statusCode === "00") {
                        dispatch(getProjectMaster(token));
                        setShow(false);
                        clearLeaveInputFields();
                        Swal.fire({
                            title: "Success!",
                            text: response.statusDesc,
                            icon: "success",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.error,
                            icon: "error",
                            confirmButtonText: "OK",
                        });
                    }
                })
                .catch(() => {
                    Swal.fire({
                        title: "Error!",
                        text: "Something went wrong. Please try again later.",
                        icon: "error",
                        confirmButtonText: "OK",
                    });
                })
        }
    };


    return (
        <div>
            <Navbar />

            <div className="main-content">
                <div className="container-fluid mt-4">
                    <div className="card3">
                        <div className="card-body">
                            <NewDataTable
                                columns={columns}
                                data={getprojectDropdownData || []}
                                tableName="PROJECTS"
                                totalRecord={getprojectDropdownData?.length ?? 0}
                            />
                            <div className="text-center">
                                <button
                                    type="button"
                                    className="btn btn-primary fw-bold mt-3"
                                    onClick={() => setShow(true)}
                                >
                                    ADD
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                className={`modal leave-modal ${show ? "d-block" : "d-none"}`}
                tabIndex="-1"
                style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
            >
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{`${projectData.actionType === "INSERT" ? "Add" : "Update"} Project`}</h5>
                            <button
                                type="button"
                                className="btn-close"
                                onClick={handleClose}
                            ></button>
                        </div>
                        <div className="modal-body">
                            <form onSubmit={handleSubmit}>
                                <div className="row mb-3">
                                    <div className="col-md-6">
                                        <label htmlFor="projectCode" className="form-label">
                                            Project Short Name <span className="text-danger">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            id="projectCode"
                                            className="form-control"
                                            name="projectCode"
                                            value={projectData.projectCode}
                                            onChange={(e) => {
                                                handleChange(e);
                                            }}
                                            required
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <label htmlFor="leaveCode" className="form-label">
                                            Project Name <span className="text-danger">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            id="projectName"
                                            className="form-control"
                                            name="projectName"
                                            value={projectData.projectName}
                                            onChange={(e) => {
                                                handleChange(e);
                                            }}
                                            required
                                        />
                                    </div>

                                </div>
                                <div className="text-center">
                                    <button type="submit" className={`btn ${projectData.actionType === "INSERT" ? "btn-success" : "btn-warning"} mt-3`}>
                                        {`${projectData.actionType === "INSERT" ? "SUBMIT" : "UPDATE"}`}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

}
export default Project;